import React from 'react';
import {Spinner} from 'reactstrap';

interface RunStatusBubbleProps {
    isRunning: boolean;
    statusMessage: string | null;
}

const RunStatusBubble: React.FC<RunStatusBubbleProps> = ({
    isRunning,
    statusMessage
}) => {
    if (!isRunning) {
        return null;
    }

    return (
        <div className="d-flex align-items-center gap-2 text-muted small my-2">
            <Spinner size="sm" />
            <span>{statusMessage ?? 'Working…'}</span>
        </div>
    );
};

export default RunStatusBubble;
